import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../../utils/api";
import { Card, Button } from "../components/AdminSharedComponents";

const AddClient = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "client",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/users", formData);
      navigate("/admin/client");
    } catch (error) {
      console.error("Error adding client:", error);
      alert(error.response?.data?.message || "Error adding client");
    }
  };

  return (
    <div className="p-6">
      <Card title="Add New Client" accentColor="primary">
        <form onSubmit={handleSubmit} className="max-w-md space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 border rounded text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 border rounded text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full p-2 border rounded text-sm"
              required
            />
          </div>

          <div className="flex gap-4">
            <Button
              type="submit"
              variant="primary"
              className="flex items-center gap-1"
            >
              Add Client
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate("/admin/client")}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddClient;
